import styles from './CustomerMessage.module.css';
import {useEffect, useState} from "react";
import HttpService from "../Services/HttpService";
import {toast} from "react-toastify";
import {toPersianDate, toPersianDigits} from "../../Component/Tools/tools";
import Button from "../../Component/Button/Button";
import NotFound from "../../Component/NotFound/NotFound";

function CustomerMessage() {

    const [listMessage, setListMessage] = useState([]);
    useEffect(() => {
        HttpService.get('Api/MessagePeople').then(res => {
            setListMessage(res.data);
        }).catch(reason => {
            toast.info('پیامی یافت نشد');
        });
    }, []);

    const [selectedMessage, setSelectedMessage] = useState(null);
    const handleOpenMessage = (message) => {
        setSelectedMessage(message);
    };
    const handleCloseMessage = () => {
        setSelectedMessage(null);
    };

    const loadMore = async () => {
        await HttpService.get(`Api/MessagePeople?lastNum=${listMessage.length}`).then(res => {
            const newMessages = res.data;
            setListMessage((prev) => [...prev, ...newMessages]);
        }).catch(reason => {
            toast.info('پیامی یافت نشد');
        });
    }

    return (
        <div style={{width: '100%', display: "flex", justifyContent: "center", flexDirection: "column"}}>
            {listMessage.length === 0 ? (
                <NotFound/>
            ) : (<table className={styles.table}>
                <thead>
                <tr>
                    <th>ردیف</th>
                    <th>نام</th>
                    <th>شماره همراه</th>
                    <th>موضوع</th>
                    <th>پیغام</th>
                    <th>زمان</th>
                </tr>
                </thead>
                <tbody>
                {listMessage.map((value, index) => (
                    <tr key={index}>
                        <td>{toPersianDigits(index + 1)}</td>
                        <td>{value.name}</td>
                        <td>{toPersianDigits(value.phone)}</td>
                        <td>{value.lable}</td>
                        <td
                            className={styles.messageCell}
                            onClick={() => handleOpenMessage(value.message)}
                            title="برای مشاهده کامل کلیک کنید"
                        >
                            {value.message.length > 25
                                ? value.message.substring(0, 25) + '...'
                                : value.message}
                        </td>
                        <td>{toPersianDigits(toPersianDate(value.createAt))}</td>
                    </tr>
                ))}
                </tbody>
            </table>)}

            <Button text={'... دریافت بیشتر'} onClick={loadMore}/>


            {/* پاپ‌آپ نمایش کامل پیام */}
            {selectedMessage && (
                <div className={styles.modalOverlay} onClick={handleCloseMessage}>
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3>متن کامل پیام</h3>
                        <p>{selectedMessage}</p>
                        <Button text={'بستن'} onClick={handleCloseMessage}/>
                    </div>
                </div>
            )}
        </div>
    );

}

export default CustomerMessage;